import React, { useState } from 'react'
import { useMutation } from '@apollo/client'
import { Container, Header, Form, Button } from 'semantic-ui-react'
import {
    LOAD_TEAM_MEMBERS_QUERY,
    ADD_MEMBER_MUTATION,
} from '../../graphql/team'
import Alert from '../Alert'

const AddMember = ({ team, onCancel }) => {
    const [email, setEmail] = useState('')
    const [firstName, setFirstName] = useState('')
    const [lastName, setLastName] = useState('')
    const [adding, setAdding] = useState(false)
    const [showAlert, setShowAlert] = useState(false)
    const [alertHeader, setAlertHeader] = useState('')
    const [alertBody, setAlertBody] = useState('')

    const [addMember] = useMutation(ADD_MEMBER_MUTATION, {
        refetchQueries: [
            {
                query: LOAD_TEAM_MEMBERS_QUERY,
                variables: { id: team.id },
            },
        ],
        awaitRefetchQueries: true,
        onError: (error) => {
            setShowAlert(true)
            setAlertHeader('Error')
            setAlertBody(`You can not add the member: ${error.message}`)
            onClose()
        },
    })

    const onClose = () => {
        setAdding(false)
        setFirstName('')
        setLastName('')
        setEmail('')
        onCancel()
    }

    const onAdd = () => {
        setAdding(true)
        addMember({
            variables: {
                teamId: team.id,
                member: {
                    email,
                    firstName,
                    lastName,
                },
            },
            onCompleted: onClose,
        })
    }

    return (
        <Container className="side-panel">
            <Alert
                show={showAlert}
                header={alertHeader}
                body={alertBody}
                onClose={() => setShowAlert(false)}
            />
            <Header size="huge">
                <Header.Content>Add member</Header.Content>
            </Header>
            <Form>
                <Form.Input
                    fluid
                    placeholder="Email address"
                    value={email}
                    onChange={(e, { value }) => setEmail(value)}
                />
                <Form.Input
                    fluid
                    placeholder="First Name"
                    value={firstName}
                    onChange={(e, { value }) => setFirstName(value)}
                />
                <Form.Input
                    fluid
                    placeholder="Last Name"
                    value={lastName}
                    onChange={(e, { value }) => setLastName(value)}
                />
                <div>
                    <Button loading={adding} onClick={onAdd}>
                        Add
                    </Button>
                    <Button onClick={onClose}>Cancel</Button>
                </div>
            </Form>
        </Container>
    )
}

export default AddMember
